<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/bcInfo.png" alt=""><span>个人信息</span></div>
      <div class="m-nav"><span>姓名</span><p>{{applyInfo.realName}}</p></div>
      <div class="m-nav"><span>证件号码</span><p>{{applyInfo.idCardNum}}</p></div>
      <div class="m-nav"><span>审核结果</span><p style="color: red">审核不通过</p></div>
      <div class="m-nav"><span>审核建议</span><p>{{applyInfo.auditRemark}}</p></div>
    </div>
    <div class="x-flex-between m-box">
      <van-button block class="m-btn-default" @click="goTo('/login')">返回登录</van-button>
      <van-button block class="x-btn-log m-btn-next" @click="goTo('/applyRegister')">重新申请</van-button>
    </div>
  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        applyInfo:this.$store.state.info.applyInfo
      }
    },
    created () {

    },
    methods: {
      goTo(i){
        this.$router.replace({
          path:i
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    background: #F4F6F9;
    padding: 0 12px 90px 12px;
    .m-bg-cover {
      position: absolute;
      left: 0;
      right: 0;
      height: 180px;
      background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
      z-index: -1;
    }
    .m-info-box {
      background: #ffffff;
      border-radius: 4px;
      padding: 15px 12px 12px 12px;
      margin-top: 18px;
      .m-info-tit {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        > img {
          width: 16px;
          height: 16px;
        }
        > span {
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
      .m-nav {
        padding-bottom: 20px;
        display: flex;
        > span {
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        > p {
          flex: 1;
          text-align: right;
        }
      }
    }
    .m-box{
      margin-top: 40px;
      .m-btn-default,.m-btn-next{
        width: 144px;
      }
      .m-btn-default{
        border-radius: 8px;
        background: #ffffff;
        color: #2B6CF9;
      }
    }
  }
</style>

